import {
  ProfileTagEventService,
  ProfileTagLifecycleService,
  ProfileTagPushEventsService,
  TrackingService
} from '@spartacus/cds';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})

export class DcpTrackingService extends TrackingService {

  constructor(
    protected profileTagLifecycleService: ProfileTagLifecycleService,
    protected profileTagPushEventsService: ProfileTagPushEventsService,
    private profileTagEventService: ProfileTagEventService
  ) {
    super(profileTagLifecycleService, profileTagPushEventsService, profileTagEventService);
  }

  /**
   * Overridden the OOB function in order to avoid notifying of the consentChanged event,
   * and not to wait for the consent to be granted to start notifying of the rest of the events.
   */
  trackEvents(): void {
    this.profileTagPushEventsService
      .getPushEvents()
      .pipe(
        tap((event) => {
          this.profileTagEventService.notifyProfileTagOfEventOccurrence(event);
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
